<!--临时客商新增  -->
<template>
	<el-dialog
		title="选择路线"
		v-if="dialogVisible"
		:visible.sync="dialogVisible"
		:close-on-click-modal="false"
		:close-on-press-escape="false"
		:modal-append-to-body="false"
		width="660px"
		class="choice-route-content"
	>
		<span slot="title" class="flex flex-middle">
			<div class="title">选择路线</div>
			<el-select
				size="small"
				class="ml10"
				clearable
				v-model="routeType"
				placeholder="请选择"
			>
				<el-option label="单人" value="1"></el-option>
				<el-option label="双人" value="2"></el-option>
				<el-option label="Min" value="0"></el-option>
			</el-select>
			<el-input
				v-model.trim="routeName"
				class="w190 ml10"
				size="small"
				placeholder="路线名称"
				clearable
			>
			</el-input>
			<img
				class="icon-s ml10"
				src="@/assets/images/search.png"
				@click="handleSearch"
				alt=""
			/>
		</span>
		<el-table
			border
			height="450"
			:data="routeList"
			:header-cell-style="{
				background: 'rgba(200, 204, 215,.6)',
				color: '#333333'
			}"
			:row-key="
				row => {
					return row.routeId;
				}
			"
			@select="handleSelect"
			@select-all="handleSelectAll"
			v-el-table-infinite-scroll="tableLoad"
		>
			<el-table-column
				type="selection"
				width="50"
				:reserve-selection="true"
				align="center"
			>
			</el-table-column>
			<el-table-column prop="routeName" label="路线名称" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="typeShow" label="类型" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="mainUserName" label="主路线员" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="licensePlate" label="车辆" :show-overflow-tooltip="true">
			</el-table-column>
		</el-table>
		<ul class="footer">
			<li>
				<el-button size="small" type="primary" @click="handleSubmit">
					确定
				</el-button>
			</li>
		</ul>
	</el-dialog>
</template>
<script>
import { debounce } from '@/utils/debounce'
export default {
	data() {
		return {
			dialogVisible: false,
			// 路线类型
			routeType: "",
			// 路线名
			routeName: "",
			// 路线列表
			routeList: [],
			// 客商
			agent: null,
			// 选中的路线
			routeSelection: [],
			// 当前组织id
			groupId: '',
			pageNo: 1,
			// 点击查询后才开启无限滚动加载
			infiniteFlag: false,
			// 防重复提交
			submitFlag: true
		};
	},
	methods: {
		init(agent, groupId) {
			this.$nextTick(() => {
				this.dialogVisible = true;
				this.submitFlag = true;
				this.groupId = groupId;
				this.routeList = [];
				this.routeSelection = [];
				this.agent = agent;
				this.infiniteFlag = false;
				// 获取当前组织路线
				this.routeInfoList();
			});
		},
		// 获取当前组织路线数据
		routeInfoList() {
			this.$request
				.post("routeMapListRoute", false, {
					groupId: this.groupId
				})
				.then(res => {
					this.routeList = res.data;
				});
		},
		// 选中路线
		handleSelect(selection, row) {
			this.routeSelection = selection;
		},
		// 路线全选
		handleSelectAll(selection) {
			this.routeSelection = selection;
		},
		handleSearch() {
			this.routeSelection = [];
			this.routeList = [];
			this.pageNo = 1;
			this.getRouteInfoList('infiniteFlag');
		},
		// 表格滚动加载
		tableLoad: debounce(function () {
			if(this.infiniteFlag) {
				this.pageNo++;
				this.getRouteInfoList('scroll');
			}
		}, 100, true),
		// 获取路线列表
		getRouteInfoList(type) {
			this.$request
				.post("routeMapChangeListPage", false, {
					routeName: this.routeName,
					routeType: this.routeType,
					pageNo: this.pageNo,
					pageSize: 50
				})
				.then(res => {
					if(type == 'infiniteFlag') {
						this.routeList = res.data.list;
						this.infiniteFlag = true;
					}
					else if (type == 'scroll') {
						this.routeList = this.routeList.concat(res.data && res.data.list || []);
					} else {
						this.routeList = res.data.list;
					}
				});
		},
		handleSubmit() {
			if (this.routeSelection.length > 0) {
				let routeIds = [];
				for (const item of this.routeSelection) {
					routeIds.push(item.routeId);
				}
				if(this.submitFlag) {
					this.submitFlag = false;
					this.$request
					.post("addRouteAgentBuff", false, {
						agentId: this.agent.agentId,
						routeIds: routeIds,
					})
					.then(res => {
						// this.$emit("handleClose");
						this.$emit("getRouteList");
						this.dialogVisible = false;
					})
					.finally(() => {
						this.submitFlag = true;
					});
				}
			} else {
				this.$message({
					type: "info",
					message: "请选择路线"
				});
			}
		}
	}
};
</script>
<style lang="scss" scoped>
.icon-s {
	width: 32px;
	height: 32px;
	cursor: pointer;
}
.delete-icon {
	width: 24px;
	height: 24px;
	cursor: pointer;
}
.footer {
	margin-top: 20px;
	display: flex;
	li {
		flex: 1;
		list-style: none;
		text-align: center;
	}
}

.choice-route-content /deep/ .el-dialog__body {
	padding: 0 5px 20px;
}

.el-table {
	// 深度选择器，去除默认的padding
	/deep/ th {
		padding: 0px;
		line-height: 34px;
	}

	/deep/ td {
		padding: 5px;
	}

	/deep/ .warning-row {
		background: #f1f1f5;
	}
	/deep/ th .el-table__cell {
		padding: 0 !important;
	}
}
</style>
